import React from 'react';
import socialStyles from './Social.module.css';

import emailIcon from '../../../assets/img/icons/social/email.svg';
import instagramIcon from '../../../assets/img/icons/social/whatsapp.svg';
import whatsappIcon from '../../../assets/img/icons/social/instagram.svg';

export function Social(props) {
  return (
    <div className={socialStyles['social-links']}>
      <a href='https://www.instagram.com/lalliancerental' target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
        <img src={instagramIcon} alt='' />
      </a>
      <a href='https://wa.me/5491131311122' target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
        <img src={whatsappIcon} alt='' />
      </a>
      <a href='mailto:info@lalliance.com.ar' target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
        <img src={emailIcon} alt='' />
      </a>
    </div>
  );
}
